import { EntityInfoType } from '../../types/entityInfo.types';
import LRPAccountForm from './_internal/LRPAccountForm';
import LRPAdditCompensationForm from './_internal/LRPAdditCompensationForm';
import LRPAcceleratedForm from './_internal/LRPAcceleratedForm';
import LRPAgenciesForm from './_internal/LRPAgenciesForm';
import LRPSchedulesForm from './_internal/LRPSchedulesForm';
import { EntityInfoCMESources } from '../Cme/getCMEFormInfo';

export const EntityInfoLRPAccounts: EntityInfoType = {
  entity: 'Ins/Account',
  editForm: LRPAccountForm,
  entityTitle: 'LRP Account',
  canDelete: false,
};

export const EntityInfoLRPAccelerated: EntityInfoType = {
  entity: 'EmpInsAccelMonth',
  entityTitle: 'Accelerated Payments',
  editForm: LRPAcceleratedForm,
};

export const EntityInfoLRPAdditCompensation: EntityInfoType = {
  entity: 'Ins/CompType',
  entityTitle: 'LRP Additional Compensation Type',
  editForm: LRPAdditCompensationForm,
  deleteLabelSuffix: 'Comp Type',
};

export const EntityInfoLRPSchedules: EntityInfoType = {
  entity: 'Ins/CommSchedule',
  editForm: LRPSchedulesForm,
  entityTitle: 'LRP Commission Schedule',
  deleteLabelSuffix: 'Schedule',
};

export const EntityInfoLRPAgencies: EntityInfoType = {
  entity: 'Ins/Agency',
  entityTitle: 'LRP Agency',
  editForm: LRPAgenciesForm,
  deleteLabelSuffix: 'Agency',
};

export function getLRPFormInfo(id: number, type: string) {
  const rowInfo = { id };
  switch (type) {
    case 'Account':
      return { ...rowInfo, ...EntityInfoLRPAccounts };
    case 'Accelerated':
      return { ...rowInfo, ...EntityInfoLRPAccelerated };
    case 'Schedule':
      return { ...rowInfo, ...EntityInfoLRPSchedules };
    case 'Addit Compensation':
      return { ...rowInfo, ...EntityInfoLRPAdditCompensation };
    case 'Agency':
      return { ...rowInfo, ...EntityInfoLRPAgencies };
    case 'Source':
      return { ...rowInfo, ...EntityInfoCMESources };
    default:
      return { id: null, editForm: null, entityTitle: null, entity: null };
  }
}
